import { ReceivingFileModel } from 'Pages/landings/newLandings/common/types'

type ValidateOptions = Record<string, unknown> & {
	text?: string
	number?: number
	size?: number
	types?: string
}

const nonDigits = /\D/g
export const isNumValidator = (options?: ValidateOptions) => (value: string) =>
	nonDigits.test(value) ? options?.text || 'Поле может состоять только из цифр' : ''

const onlyCyrillicCharsWithHyphen = /[^а-яё\s-]/i
export const validateCyrillicsWithHyphen = (options?: ValidateOptions) => (value: string) =>
	onlyCyrillicCharsWithHyphen.test(value)
		? options?.text || 'Необходимо использовать кириллицу'
		: ''

export const required = (options?: ValidateOptions) => (value: string) =>
	value ? '' : options?.text || 'Пожалуйста заполните'

export const validateInn =
	(
		options?: ValidateOptions & {
			isTwelve?: boolean
		}
	) =>
	(value: string) => {
		let inn = value
		const isNum = isNumValidator()(value)
		if (isNum) return isNum

		if (typeof inn !== 'string') {
			inn = ''
		}

		if (Number(inn) <= 0) {
			return 'ИНН не может состоять из нулей'
		}
		if ((options?.isTwelve ? [12] : [10, 12]).indexOf(inn.length) === -1) {
			return options?.isTwelve
				? 'ИНН может состоять только из 12 цифр'
				: 'ИНН может состоять только из 10 или 12 цифр'
		}
		const checkDigit = (inn: string, coefficients: number[]) => {
			let verify = 0
			coefficients.forEach((coef, idx) => {
				verify += coef * Number(inn[idx])
				return null
			})
			return (verify % 11) % 10
		}

		switch (inn.length) {
			case 10:
				if (checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]) === parseInt(inn[9], 10)) {
					return ''
				}
				break
			case 12:
				if (
					checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === parseInt(inn[10], 10) &&
					checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]) === parseInt(inn[11], 10)
				) {
					return ''
				}
				break
			default:
				return 'Неправильный номер ИНН'
		}
		return 'Неправильный номер ИНН'
	}

const phoneRegExp = /^[+][(]?[7][3489][0-9]{2}[)]?[-\s.]?[0-9]{7}$/
export const validatePhone = (options?: ValidateOptions) => (value: string) =>
	phoneRegExp.test(value)
		? ''
		: options?.text || 'Введите корректный номер телефона начиная с +7 без символов «(), -»'

export const validateFileRequired = () => (value: ReceivingFileModel[]) =>
	value.length ? null : { title: 'Ошибка', info: 'Загрузите файл' }

export const validateFileLength = (options?: ValidateOptions) => (value: ReceivingFileModel[]) =>
	value.length > options.number
		? { title: 'Ошибка загрузки файлов', info: `Загрузите до ${options.number} файлов` }
		: null
export const validateFileSize = (options?: ValidateOptions) => (value: ReceivingFileModel[]) =>
	value?.filter((file) => file?.size > options.size)?.length
		? {
				title: `Ошибка загрузки ${value?.length > 1 ? 'файлов' : 'файла'}`,
				info: `Загрузите файл до ${options.size / 1024 / 1024} МБ`,
		  }
		: null
export const validateFileType = (options?: ValidateOptions) => (value: ReceivingFileModel[]) =>
	value?.filter((file) =>
		options?.types
			? !options.types
					?.toLocaleLowerCase()
					.includes(file?.name?.toLocaleLowerCase()?.split('.')?.pop())
			: false
	).length
		? {
				title: `Ошибка загрузки ${value?.length > 1 ? 'файлов' : 'файла'}`,
				info: `${
					value?.length > 1 ? 'Допустимые расширения файлов:' : 'Допустимое расширение файла:'
				} ${options?.types}`,
		  }
		: null
